// Matches www/pro.fiverr.com, bare fiverr.com, and any locale subdomain (de.fiverr.com,
// es.fiverr.com, …) — anything else (recruiter.f-labs.dev, localhost, Okteto hosts) is dev.
export const PROD_FIVERR_HOST_PATTERN = /(^|\.)fiverr\.com$/;
// dev.fiverr.com and its locales (de.dev.fiverr.com, es.dev.fiverr.com, …) end in
// .fiverr.com too but are dev environments, not prod.
export const DEV_FIVERR_HOST_PATTERN = /(^|\.)dev\.fiverr\.com$/;
export const MIRA_PROD_URL = 'https://mira.fiverr.com';
export const MIRA_DEV_URL = 'https://recruiter.f-labs.dev';
export const MIRA_ENTRY_PATH = '/api/v1/entry/start';
